<template>
  <table class="uk-table" border="1">
    <thead>
      <tr v-for="(row, rowIndex) in headers" :key="rowIndex">
        <th v-for="(col, colIndex) in row" :colspan="col.colspan" :rowspan="col.rowspan" :key="colIndex" :style="col.style">
          {{ col.text }}
          <HelpIcon
            v-if="col.helpIconMessage"
            :tooltipText="col.helpIconMessage"
            position="top-left"
            cls="uk-active uk-width-auto"
          />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr :class="systemDefined(data.id) ? 'gray center' : 'center'" v-for="(data, index) in datas" :key="index">
        <td class="name">{{ data.name }}</td>
        <td>
          <label>{{ operationRanges[data.operationRange] }}</label>
        </td>
        <td>
          <label v-if="systemDefined(data.id)">-</label>
          <ActionButton
            v-if="!systemDefined(data.id)"
            title="編集"
            color="primary"
            :width="100"
            :height="35"
            @click="$emit('open-form', 'edit', data)"
          />
        </td>
        <td>
          <input
            type="checkbox"
            class="checkbox"
            @change="$emit('employee', 'read')"
            :checked="data.permissions.employee.includes('read')"
            disabled
          />
        </td>
        <td>
          <input
            type="checkbox"
            class="checkbox"
            @change="$emit('employee', 'edit')"
            :checked="data.permissions.employee.includes('edit')"
            disabled
          />
        </td>
        <td>
          <input
            type="checkbox"
            class="checkbox "
            @change="$emit('employeeStats', 'read')"
            :checked="data.permissions.employeeStats.includes('read')"
            disabled
          />
        </td>
        <td>
          <input
            type="checkbox"
            class="checkbox"
            @change="$emit('applicant', 'read')"
            :checked="data.permissions.applicant.includes('read')"
            disabled
          />
        </td>
        <td>
          <input
            type="checkbox"
            class="checkbox"
            @change="$emit('applicant', 'edit')"
            :checked="data.permissions.applicant.includes('edit')"
            disabled
          />
        </td>
        <td>
          <input
            type="checkbox"
            class="checkbox"
            @change="$emit('applicantStats', 'read')"
            :checked="data.permissions.applicantStats.includes('read')"
            disabled
          />
        </td>
        <td>
          <input
            type="checkbox"
            class="checkbox"
            @change="$emit('analysis', 'read')"
            :checked="data.permissions.analysis.includes('read')"
            disabled
          />
        </td>
        <td colspan="3">
          <input
            type="checkbox"
            class="checkbox"
            @change="$emit('as', 'edit')"
            :checked="data.permissions.asBroadcast.includes('edit')"
            disabled
          />
        </td>
        <td colspan="3">
          <input
            type="checkbox"
            class="checkbox"
            @change="$emit('manage', 'edit')"
            :checked="data.permissions.manage.includes('edit')"
            disabled
          />
        </td>
        <td colspan="3">
          <input
            type="checkbox"
            class="checkbox"
            @change="$emit('specialManage', 'edit')"
            :checked="data.permissions.specialManage.includes('edit')"
            disabled
          />
        </td>
      </tr>
      <tr class="center">
        <td style="border-left: hidden; border-right: hidden; border-bottom: hidden">
          <img
            v-if="!isOpenNewTagForm"
            src="@/assets/image/plus.png"
            class="uk-margin-small-top plus-icon"
            @click="$emit('open-form', 'add')"
          />
        </td>
        <td colspan="18" style="border-right: hidden; border-bottom: hidden;"></td>
      </tr>
    </tbody>
  </table>
</template>
<style lang="scss" scoped>
.uk-table {
  border: thin solid #e5e5e5;

  th {
    text-align: center;
    vertical-align: middle;
    font-size: 16px;
  }
  td {
    font-size: 14px;
  }
  th,
  td {
    vertical-align: middle;
    padding: 2px;
  }
  .name {
    color: #666;
  }
}
.checkbox {
  width: 28px;
  height: 28px;
}
.center {
  text-align: center;
}
.gray {
  background: #f8f8f8;
}

tr:nth-child(n + 4):nth-child(2n):not(:last-child) {
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6) {
    background: lighten($color: #b8dcff, $amount: 4);
  }

  td:nth-child(7),
  td:nth-child(8),
  td:nth-child(9) {
    background: lighten($color: #ffdbbd, $amount: 4);
  }

  td:nth-child(10) {
    background: lighten($color: #b8dcff, $amount: 4);
  }

  td:nth-child(11) {
    background: lighten($color: #f9f1d2, $amount: 4);
  }
  td:nth-child(12) {
    background: lighten($color: #e4f6d5, $amount: 4);
  }

  td:nth-child(13),
  td:nth-child(14) {
    background: lighten($color: #ffe8ef, $amount: 3);
  }
}

tr:nth-child(n + 4):nth-child(2n + 1):not(:last-child) {
  td:nth-child(4),
  td:nth-child(5),
  td:nth-child(6) {
    background: lighten($color: #b8dcff, $amount: 4);
  }

  td:nth-child(7),
  td:nth-child(8),
  td:nth-child(9) {
    background: lighten($color: #ffdbbd, $amount: 4);
  }

  td:nth-child(10) {
    background: lighten($color: #b8dcff, $amount: 4);
  }

  td:nth-child(11) {
    background: lighten($color: #f9f1d2, $amount: 4);
  }
  td:nth-child(12) {
    background: lighten($color: #e4f6d5, $amount: 4);
  }

  td:nth-child(13),
  td:nth-child(14) {
    background: lighten($color: #ffe8ef, $amount: 3);
  }
}
</style>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import Page from "../molecules/Page.vue";
import { Prop } from "vue-property-decorator";
import { PropType } from "vue";
import ActionButton from "../atoms/ActionButton.vue";
import { OperationRangesEnum } from "../../autogen";
import HelpIcon from "../atoms/HelpIcon.vue";

@Options({
  components: {
    Page,
    ActionButton,
    HelpIcon
  }
})
export default class AuthorityTable extends Vue {
  @Prop({ type: Array as PropType<Object> }) datas: Object[] = [];
  @Prop({ type: Array as PropType<Array<Object>> }) headers: Object[][] = [];

  get operationRanges() {
    return OperationRangesEnum;
  }

  systemDefined(id: string): boolean {
    return ["1", "2", "3", "4"].includes(id);
  }
}
</script>
